








































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import api from '@/api/distributor/index'
@Component({
  components: {
    CustomForm
  }
})
export default class Withdrawal extends AbpBase {
  filters = [
    {
      label: '姓名',
      type: 'input',
      props: {
        placeholder: '请输入分销员姓名'
      },
      key: 'keyWord'
    }
  ]
  columns = [
    {
      title: '用户账号',
      key: 'userName'
    },
    {
      title: '姓名',
      key: 'name'
    },
    {
      title: '提现金额',
      key: 'withdrawnCash'
    },
    {
      title: '状态',
      key: 'reviewStatus',
      slot: 'reviewStatus'
    },
    {
      title: '申请时间',
      key: 'creationTime',
      slot: 'creationTime'
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action'
    }
  ]
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  }
  data = []
  failReason = ''
  mounted() {
    this.loadData((this.$refs.lineForm as any).form)
  }
  getStatusDisplayName(statue) {
    switch (statue) {
      case 0:
        return '待审核'
      case 1:
        return '通过'
      case 2:
        return '不通过'
      default:
        return ''
    }
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  loadData(form = {}) {
    let keyWord = form['keyWord']
    api
      .getWithdrawRecord(this.pager.pageSize, this.pager.pageIndex, '', keyWord)
      .then(res => {
        this.pager.total = res.data.totalCount
        this.data = res.data.items
      })
  }
  submitChange(form, valid) {
    if (valid) {
      this.loadData(form)
    }
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  ok(id) {
    //1通过
    api
      .verifyWithdrawRecord(id, { reviewStatus: 1, failReason: '' })
      .then(res => {
        this.$Message.success('操作成功')
        this.loadData((this.$refs.lineForm as any).form)
      })
  }
  cancel(id) {
    //2拒绝
    this.$Modal.confirm({
      render: h => {
        return h('Input', {
          props: {
            value: this.failReason,
            autofocus: true,
            placeholder: '请输入不通过原因...'
          },
          on: {
            input: val => {
              this.failReason = val
            }
          }
        })
      },
      onOk: () => {
        api
          .verifyWithdrawRecord(id, {
            reviewStatus: 2,
            failReason: this.failReason
          })
          .then(res => {
            this.$Message.success('操作成功')
            this.loadData((this.$refs.lineForm as any).form)
          })
      }
    })
  }
}
